import React, { useCallback } from 'react';
import type { ParamListBase } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import {
  useSafeNavigation,
  useSafeRouteParams,
  useSafeRouter,
} from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

import { useIsUpsellScreenEnabled } from '../../hooks';
import { Customization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationScreen = () => {
  const navigation =
    useSafeNavigation<NativeStackNavigationProp<ParamListBase>>();
  const router = useSafeRouter();
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const routeParams = useSafeRouteParams<CustomizationScreenRouteParams>();

  const { restaurantSlug, productSlug, reorderLineItemId } = routeParams;

  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (isUpsellScreenEnabled) {
      if (isExpoRouterEnabled) {
        router?.replace('/upsell');
        return;
      }

      navigation?.replace('UpsellScreen');
      return;
    }

    if (isExpoRouterEnabled) {
      router?.replace({ pathname: '/bag', params: { referrer: 'Menu' } });
      return;
    }

    navigation?.replace('Bag', { referrer: 'Menu' });
  }, [navigation, router, isExpoRouterEnabled, isUpsellScreenEnabled]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Customization
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      isEditProductMode={false}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationScreenRouteParams = {
  restaurantSlug: string;
  productSlug: string;
  reorderLineItemId?: string;
};
